import R from "core/resources";
import Component, { Align } from "core/gui/component";
export default function ItemsDisplay(player) {
  const component = Component({
    alignment: {
      x: Align.Right,
      y: Align.Top
    },
    size: {
      width: 150,
      height: 150
    }
  });
  const font = R.fonts.steelfish;
  component.renderComponent = p => {
    const {
      items
    } = player;
    const {
      width
    } = component.size;
    const sortedItems = Object.entries(items).sort(([name, count]) => name.includes("key") ? 1 : -1);
    let y = 10;
    for (const [name, count] of sortedItems) {
      const {
        sprite
      } = R.gfx.items.getSprite(name);
      const spriteX = width - 80;
      const spriteY = y;
      renderItem(p, sprite, spriteX, spriteY);
      renderCount(p, sprite, count, spriteX, spriteY);
      y += sprite.height;
    }
  };
  function renderItem(p, sprite, x, y) {
    p.image(sprite, x, y);
  }
  function renderCount(p, sprite, count, x, y) {
    if (count < 2) return;
    const {
      width,
      height
    } = sprite;
    const text = "" + count;
    const textX = x + width;
    const textY = y + height;
    p.noStroke();
    p.fill(255);
    p.textSize(32);
    p.textAlign(p.RIGHT, p.BOTTOM);
    p.textFont(font);
    p.text(text, textX, textY);
  }
  return component;
}